import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Button from '@nubank/nuds-web/components/Button/Button';

import AdvantagesList from '../AdvantagesList/AdvantagesList';

import HeaderBlock from './styles/HeaderBlock';
import ListBlock from './styles/ListBlock';
import SectionRoot from './styles/SectionRoot';
import { TabletAndLargerOnlyCTABlock, MobileOnlyCTABlock } from './styles/CTABlock';

function AdvantagesSection({
  onButtonClick,
  buttonLabel,
  isRegistrationFormOpen,
  index,
}) {
  return (
    <SectionRoot>
      <HeaderBlock>
        <Typography
          variant="title"
          intlKey={`cms.businessAccountPage.cardsArea[${index}].title`}
        />
        <TabletAndLargerOnlyCTABlock>
          <Button
            onClick={onButtonClick}
            intlKey={buttonLabel}
            aria-expanded={isRegistrationFormOpen}
          />
        </TabletAndLargerOnlyCTABlock>
      </HeaderBlock>
      <ListBlock
        alignItems="center"
      >
        <AdvantagesList index={index} />
      </ListBlock>
      <MobileOnlyCTABlock>
        <Button
          onClick={onButtonClick}
          intlKey={buttonLabel}
          aria-expanded={isRegistrationFormOpen}
        />
      </MobileOnlyCTABlock>
    </SectionRoot>
  );
}

AdvantagesSection.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isRegistrationFormOpen: PropTypes.bool.isRequired,
  onButtonClick: PropTypes.func.isRequired,
};

export default React.memo(AdvantagesSection);
